<template>
    <v-form @submit.prevent="savePassword()">
        <v-card>
            <v-card-title style="background-color: #1976d2; color: white">
                <v-icon size="x-small" color="light">mdi-square-edit-outline</v-icon>
                Changement du mot de passe
            </v-card-title>
            <v-divider> </v-divider>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="current_user.old_password"
                                :append-icon="show0 ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[rules.required]"
                                :type="show0 ? 'text' : 'password'"
                                label="Ancien mot de passe"
                                prepend-inner-icon="mdi-lock-outline"
                                @click:append="show0 = !show0"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="current_user.new_password"
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[rules.required, rules.min]"
                                :type="show1 ? 'text' : 'password'"
                                label="Nouveau mot de passe"
                                :hint="hint"
                                counter
                                prepend-inner-icon="mdi-lock-outline"
                                @click:append="show1 = !show1"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="current_user.confirm_password"
                                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[rules.required, rules.min]"
                                :type="show2 ? 'text' : 'password'"
                                name="input-10-1"
                                label="Confirmation du mot de passe"
                                :hint="hint"
                                counter
                                prepend-inner-icon="mdi-lock-outline"
                                @click:append="show2 = !show2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider> </v-divider>

            <v-card-actions color="white" style="background-color: #F2F2F2">
                <v-row>
                    <v-col cols="7">
                    </v-col>
                    <v-col cols="5" class="text-right">
                        <v-btn type="submit" size="small" color="success" variant="flat" class="me-1 text-none" prepend-icon="mdi-content-save">Enregistrer</v-btn>
                        <v-btn color="red" size="small" variant="flat" class="text-none" prepend-icon="mdi-cancel" @click="$emit('dialog', false)">Annuler</v-btn>
                    </v-col>
                </v-row>
                
            </v-card-actions>
        </v-card>
        <v-alert v-show="error_message !== ''" border="start"  v-model="alert" closable type="error">{{ error_message }}</v-alert>
    </v-form>
</template>

<script>
import { APIAccount } from "@/store/api";
import store from '@/store/index.js'
export default {
    name: 'ChangePassword',
    data() {
        return {
            current_user : {
                old_password: '',
                new_password: '',
                confirm_password: '',
            },

            show0: false,
            show1: false,
            show2: false,
        
            rules: {
                required: value => !!value || 'Champs obligatoire.',
                min: v => v.length >= 8 || 'Minimum 8 caractères',
                emailMatch: () => (`Le mot de passe que vous avez entré ne correspond pas`),
            },

            alert: false,
            error_message: "Les champs du nouveau mot de passe ne correspondent pas.",
            hint: "Le mot de passe deoit comporter 8 caractères minimum incluant lettres, chiffres et caractères spéciaux.",
        }
    },
    methods: {
        savePassword() {
            APIAccount.put(`change_password/${ store.getters.user.id }/`, this.current_user)
            .then(() => {
                this.$emit("dialog", false);
            })
            .catch((error) => {
                this.alert = true
                this.error_message = error.response?.data?.password[0]
            });
        }
    },        
}
</script>
